import { platformBrowser } from '@angular/platform-browser';
import { AppModule } from './app/app-module';

// Register the combined service worker as early as possible so desktop
// notifications are shown through it (no browser "localhost:4213"/origin line)
// and it is active well before the first notification fires. mobimed-sw.js
// bundles the notification handlers with the Angular PWA runtime (ngsw) — in
// dev builds ngsw-worker.js doesn't exist and the worker degrades to
// notifications-only. Registering one file for both keeps the root scope sane:
// two competing registrations would evict each other.
if ('serviceWorker' in navigator) {
  // updateViaCache 'none': browsers fetch importScripts (notif-sw / ngsw-worker)
  // THROUGH the HTTP cache by default, so a proxy/nginx serving them with a long
  // max-age pins installed clients (iOS PWAs especially) to a dead worker forever.
  navigator.serviceWorker.register('/mobimed-sw.js', { updateViaCache: 'none' }).catch(() => { /* non-fatal */ });
}

platformBrowser().bootstrapModule(AppModule, {

})
  .catch(err => console.error(err));
